import { Super } from './super.model';

export class Contact extends Super<Contact>{

    public id:number;
    public name:string;
    public description:string;
    public type:string;
    public nature:string;
    public email:string;
    public phone1:string;
    public phone2:string;
    public phone3:string
    public bp:string;
    public fax:string;
    public twitter:string;
    public facebook:string;
    public whatsapp:string;
    public linkedin:string;
    public website:string;
    public picture:File;
    public gender:string;


}


